import { render, staticRenderFns } from "./markupsPopup.vue?vue&type=template&id=ae6ea336"
import script from "./markupsPopup.vue?vue&type=script&lang=js"
export * from "./markupsPopup.vue?vue&type=script&lang=js"
import style0 from "./markupsPopup.vue?vue&type=style&index=0&id=ae6ea336&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports